import { POOL_CAPACITY } from '../constants';
import { DeterministicRandom } from '../math/DeterministicRandom';
import { IndexPool } from './IndexPool';

export class ParticlePool {
  readonly indices = new IndexPool(POOL_CAPACITY.particles);
  readonly x = new Float32Array(POOL_CAPACITY.particles);
  readonly y = new Float32Array(POOL_CAPACITY.particles);
  readonly vx = new Float32Array(POOL_CAPACITY.particles);
  readonly vy = new Float32Array(POOL_CAPACITY.particles);
  readonly life = new Float32Array(POOL_CAPACITY.particles);
  readonly maxLife = new Float32Array(POOL_CAPACITY.particles);
  readonly size = new Float32Array(POOL_CAPACITY.particles);
  readonly color = new Uint8Array(POOL_CAPACITY.particles);
  readonly frame = new Uint8Array(POOL_CAPACITY.particles);
  overflowDrops = 0;

  spawn(x: number, y: number, vx: number, vy: number, life: number, size: number, color: number, frame = 0): number {
    const index = this.indices.acquire();
    if (index < 0) {
      this.overflowDrops += 1;
      return -1;
    }
    this.x[index] = x;
    this.y[index] = y;
    this.vx[index] = vx;
    this.vy[index] = vy;
    this.life[index] = life;
    this.maxLife[index] = life;
    this.size[index] = size;
    this.color[index] = color;
    this.frame[index] = frame;
    return index;
  }

  burst(rng: DeterministicRandom, x: number, y: number, count: number, speed: number, life: number, color: number): void {
    for (let i = 0; i < count; i += 1) {
      const angle = rng.nextFloat() * Math.PI * 2;
      const magnitude = speed * (0.45 + rng.nextFloat() * 0.55);
      this.spawn(x, y, Math.cos(angle) * magnitude, Math.sin(angle) * magnitude, life * (0.65 + rng.nextFloat() * 0.35), 1 + rng.nextFloat() * 2, color, i % 6);
    }
  }

  update(): void {
    // HOTPATH-BEGIN
    const active = this.indices.active;
    for (let i = 0; i < active.length; i += 1) {
      if (active[i] === 0) continue;
      this.x[i] += this.vx[i];
      this.y[i] += this.vy[i];
      this.vx[i] *= 0.96;
      this.vy[i] *= 0.96;
      this.life[i] -= 1;
      if (this.life[i] <= 0) this.indices.release(i);
    }
    // HOTPATH-END
  }

  reset(): void {
    this.indices.reset();
    this.overflowDrops = 0;
  }
}
